<span class='p-text-secondary' *ngIf='isLoading && !hasError'>
  <i class='pi pi-spin pi-spinner'></i>
</span>
<span *ngIf='!isLoading && !hasError'>{{ value }}</span>
<span *ngIf='hasError' class='p-text-bold'>N/A</span>
